import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//获取 团队人员列表
export const getUserTreeData = (params={}) => {
    const url = adminApi  + 'report/user/userTree'
    return http.fetchGet(url, params);
}

export const addExcludeNodes = (params={}) => {
    const url = adminApi  + 'report/user/addExcludeNodes'
    return http.fetchPost(url, params);
}

export const delExcludeNodes = (params={}) => {
    const url = adminApi  + 'report/user/delExcludeNodes'
    return http.fetchPost(url, params);
}

export const updateMember = (params={}) => {
    const url = adminApi  + 'report/user/updateMember'
    return http.fetchPost(url, params);
}

export const deleteMemberByUid = (params={}) => {
    const url = adminApi  + 'report/user/deleteMemberByUid'
    return http.fetchPost(url, params);
}

export const moveCurPermission = (params={}) => {
    const url = adminApi  + 'report/user/movePermission'
    return http.fetchPost(url, params);
}

export const feedback = (params={}) => {
    const url = adminApi  + 'common/feedbackAdd'
    return http.fetchPost(url, params);
}

export const visitAdd = (params={}) => {
    const url = adminApi  + 'common/visitAdd'
    return http.fetchPost(url, params);
}


export const getUserInfo = (params={}) => {
    const url = adminApi  + 'common/getUserInfo'
    return http.fetchPost(url, params);
}

export const getOplog = (params={}) => {
    const url = adminApi  + 'report/user/getOpLog'
    return http.fetchGet(url, params);
}

export const getTeamList = (params={}) => {
    const url = adminApi  + 'report/user/teamList'
    return http.fetchGet(url, params);
}

export const addMember = (params={}) => {
    const url = adminApi  + 'report/user/addMember'
    return http.fetchPost(url, params);
}

